import { CompassusCarePlanServiceImplFactory } from "../../core/impl/compassusCarePlanServiceImpl";
import { IPatchCompassusCarePlanRequest } from "../driven/repositories/compassusCarePlanRepository";

export const CompassusCarePlanControllerFactory = ({
  compassusCarePlanService,
}: {
  compassusCarePlanService: ReturnType<
    typeof CompassusCarePlanServiceImplFactory
  >;
}) => {
  const getCarePlan = ({
    clinicId,
    patientId,
  }: {
    clinicId: number;
    patientId: number;
  }) => compassusCarePlanService.getCarePlan({ clinicId, patientId });

  const patchCarePlan = ({
    clinicId,
    patientId,
    body,
  }: {
    clinicId: number;
    patientId: number;
    body: IPatchCompassusCarePlanRequest;
  }) => compassusCarePlanService.patchCarePlan({ clinicId, patientId, body });

  const acquireEditLock = ({
    clinicId,
    patientId,
    editingSessionId,
  }: {
    clinicId: number;
    patientId: number;
    editingSessionId: string;
  }) =>
    compassusCarePlanService.acquireEditLock({
      clinicId,
      patientId,
      editingSessionId,
    });

  const releaseEditLock = ({
    clinicId,
    patientId,
    editingSessionId,
  }: {
    clinicId: number;
    patientId: number;
    editingSessionId: string;
  }) =>
    compassusCarePlanService.releaseEditLock({
      clinicId,
      patientId,
      editingSessionId,
    });

  const getVersions = ({
    clinicId,
    patientId,
    monthOffset,
    daysBack,
    daysForward,
    excludeDaysBack,
  }: {
    clinicId: number;
    patientId: number;
    monthOffset?: number;
    daysBack?: number;
    daysForward?: number;
    excludeDaysBack?: number;
  }) =>
    compassusCarePlanService.getVersions({
      clinicId,
      patientId,
      monthOffset,
      daysBack,
      daysForward,
      excludeDaysBack,
    });

  const getVersion = ({
    clinicId,
    patientId,
    versionId,
  }: {
    clinicId: number;
    patientId: number;
    versionId: number;
  }) => compassusCarePlanService.getVersion({ clinicId, patientId, versionId });

  const patchVersion = ({
    clinicId,
    patientId,
    versionId,
    versionName,
  }: {
    clinicId: number;
    patientId: number;
    versionId: number;
    versionName: string | null;
  }) =>
    compassusCarePlanService.patchVersion({
      clinicId,
      patientId,
      versionId,
      versionName,
    });

  const getVersionDiff = ({
    clinicId,
    patientId,
    versionId,
  }: {
    clinicId: number;
    patientId: number;
    versionId: number;
  }) =>
    compassusCarePlanService.getVersionDiff({ clinicId, patientId, versionId });

  const restoreVersion = ({
    clinicId,
    patientId,
    versionId,
  }: {
    clinicId: number;
    patientId: number;
    versionId: number;
  }) =>
    compassusCarePlanService.restoreVersion({ clinicId, patientId, versionId });

  const exportCarePlan = ({
    clinicId,
    patientId,
  }: {
    clinicId: number;
    patientId: number;
  }) => compassusCarePlanService.exportCarePlan({ clinicId, patientId });

  return {
    getCarePlan,
    patchCarePlan,
    acquireEditLock,
    releaseEditLock,
    getVersions,
    getVersion,
    patchVersion,
    getVersionDiff,
    restoreVersion,
    exportCarePlan,
  };
};
